var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1185,
    height: 1506,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: "0%",
    x2: "100%",
    y1: "0%",
    x1: "0%",
    id: "grad1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD158",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD158",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    d: "m408.30912,386.51619c0,-100.1 81.2,-181.3 181.3,-181.3l0,0c100.1,0 181.3,81.2 181.3,181.3l0,223.9l202.6,0l0,-223.9c0,-212 -171.9,-383.9 -383.9,-383.9l0,0c-212,0 -383.9,171.9 -383.9,383.9l0,223.9l202.6,0l0,-223.9z",
    fill: "url(#grad1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m1045.20912,659.71619l-911.1,0c-74.8,0 -135.5,60.7 -135.5,135.5l0,569.9c0,74.8 60.7,135.5 135.5,135.5l911.1,0c74.8,0 135.5,-60.7 135.5,-135.5l0,-569.9c0,-74.9 -60.7,-135.5 -135.5,-135.5z",
    fill: "url(#grad1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.774eb1c1d06e09610b69c95ddd35ace2.svg";
export { ForwardRef as ReactComponent };